import _defineProperty from "C:\\Users\\SB user\\Desktop\\Morpho\\website\\MPS_WEB\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";

var getRTLStyle = function getRTLStyle(_ref) {
  var _ref2;

  var componentCls = _ref.componentCls,
      menuArrowOffset = _ref.menuArrowOffset;
  return _ref2 = {}, _defineProperty(_ref2, "".concat(componentCls, "-rtl"), {
    direction: 'rtl'
  }), _defineProperty(_ref2, "".concat(componentCls, "-submenu-rtl"), {
    transformOrigin: '100% 0'
  }), _defineProperty(_ref2, "".concat(componentCls, "-rtl").concat(componentCls, "-vertical,\n    ").concat(componentCls, "-submenu-rtl ").concat(componentCls, "-vertical"), _defineProperty({}, "".concat(componentCls, "-submenu-arrow"), {
    '&::before': {
      transform: "rotate(-45deg) translateY(-".concat(menuArrowOffset, ")")
    },
    '&::after': {
      transform: "rotate(45deg) translateY(".concat(menuArrowOffset, ")")
    }
  })), _ref2;
};

export default getRTLStyle;